import { defineMessages } from 'react-intl';

const messages = defineMessages({
  error: {
    id: 'AreaGraph.Error',
    defaultMessage: 'There was a problem loading this info. Please try again.',
  },
  errorButton: {
    id: 'AreaGraph.ErrorButton',
    defaultMessage: 'Try again',
  },
});

export default messages;
